
@if (bfvdZeroResultsMsg !== '') {
  <div class="threedViewer structureContainer">
    <p class="noRecMsg">{{ bfvdZeroResultsMsg }}</p>
  </div>
}

@if (isDatabaseErrorBFVD) {
  <div class="threedViewer structureContainer">
    <p class="k36-i">There is an issue with this entry. Please report it to us at <a href="mailto:afdbhelp@ebi.ac.uk">afdbhelp&#64;ebi.ac.uk</a> and include the accession number you were trying to access.</p>
  </div>
}

@if (bfvdZeroResultsMsg === '' && !isDatabaseErrorBFVD && !isBFVDLoading) {
  <div>
    <table mat-table [dataSource]="bfvdStructureDataSource" class="mat-elevation-z8 structureTable"
      matSort matSortActive="evalue" matSortDirection="desc" (matSortChange)="sortTable($event)"
      matSortDisableClear multiTemplateDataRows>

      <ng-container matColumnDef="expand">
        <th class="firstexpand arrow" mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element" class="arrow-box" [ngClass]="!isExpandedBFVD(element) ? '' : 'arrow-active'">
          <div class="mobile-view">
            <div class="mobile-wrapfirsttd">
              <button (click)="toggleRowBFVD(element); $event.stopPropagation()" mat-icon-button aria-label="expand row" class="icon-button">
                @if (!isExpandedBFVD(element)) {
                  <span class="mobile-arrow-title-text"> Open pairwise alignment
                    @if (!isExpandedBFVD(element)) {
                      <img src="assets/img/down-arrow.svg" alt="uparrow" class="newimg" width="10" height="5">
                    }
                  </span>
                }
                @if (isExpandedBFVD(element)) {
                  <span class="mobile-arrow-title-text"> Close pairwise alignment <img src="assets/img/arrow-dropping.svg" alt="downarrow" class="newimg" width="10" height="5"></span>
                }
              </button>
            </div>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="expandedDetailBFVD">
        <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumnsBFVDStructure.length">
          @if (isExpandedBFVD(element)) {
            <div class="example-element-detail">
              <app-sequence-card [hsps]="element.hsps" [isExpandStructure]="true"></app-sequence-card>
            </div>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="alighin3D">
        <th class="fifth alignin3d" mat-header-cell *matHeaderCellDef>Align <br/>in 3D</th>
        <td mat-cell *matCellDef="let element">
          <div class="switch-af">
            <span class="mobile-view-title">Align in 3D</span>
            <input type="checkbox"
              [disabled]="disabledState[element.afdbAccessions.split('*')[0]] || false"
              [checked]="checkboxState[element.afdbAccessions.split('*')[0]] || false"
              id="bfvd-{{ element.afdbAccessions.split('*')[0] }}"
              value="{{ element.afdbAccessions.split('*')[0] }}"
              (mousedown)="$event.stopPropagation()" (click)="$event.stopPropagation()"
              (change)="clickToggleSuperpose($event, element.afdbAccessions.split('*')[0]); $event.stopPropagation();" />
            <label for="bfvd-{{ element.afdbAccessions.split('*')[0] }}">
              <img src="../../assets/img/FatX.svg" alt="FatX" class="unchecked-icon" width="20" height="20">
              <img src="../../assets/img/base-switch_icon.svg" alt="check" class="checked-icon" width="21" height="20">
            </label>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="afdbAccessions">
        <th class="first" mat-header-cell *matHeaderCellDef><span>AFDB accession</span></th>
        <td mat-cell *matCellDef="let element">
          <span class="mobile-view mobile-view-title">AFDB accession</span>
          <div class="target-desc mobile-view">
            @if (element.afdbAccessions !== 'Unavailable') {
              <span class="titleBadges"><a class="accessLink" href="{{ element.refLinkId }}" target="_blank">{{ element.targetToShow }}</a></span>
            }
          </div>
          <div class="target-desc nonMobile">
            @if (element.afdbAccessions !== 'Unavailable') {
              <span class="titleBadges"><a class="accessLink" href="{{ element.refLinkId }}" target="_blank">{{ element.targetToShow }}</a></span>
            }
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="speciesNames">
        <th class="third-species" mat-header-cell *matHeaderCellDef>Species</th>
        <td mat-cell *matCellDef="let element">
          <span class="mobile-view mobile-view-title">Species</span>
          <span class="mobile-view"><i>{{ element.speciesNames }}</i></span>
          <span class="nonMobile">
            @if (element.speciesNames.length > 20) {
              <div class="label-tooltip"><p class="descEllipseSpec"><i>{{ element.speciesNames.slice(0,20) }}...</i></p><span class="label-tooltip-text">{{ element.speciesNames }}</span></div>
            }
            @if (element.speciesNames.length <= 20) {
              <div><p class="descEllipseSpec-norm"><i>{{ element.speciesNames }}</i></p></div>
            }
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="sequenceLength">
        <th class="fourth" mat-header-cell *matHeaderCellDef>Residue <br/>range</th>
        <td mat-cell *matCellDef="let element">
          <span class="mobile-view mobile-view-title">Residue range</span>{{ element.sequenceLength }}
        </td>
      </ng-container>

      <ng-container matColumnDef="evalue">
        <th class="eval" mat-header-cell *matHeaderCellDef mat-sort-header="evalue">E-value</th>
        <td mat-cell *matCellDef="let element">
          <span class="mobile-view mobile-view-title">E-value</span>{{ element.evalue }}
        </td>
      </ng-container>

      <ng-container matColumnDef="sequenceIdentity">
        <th class="fourth thirdid" mat-header-cell *matHeaderCellDef mat-sort-header>
          <div style="display: flex; flex-direction: row; align-items:end;">Seq. <br>identity</div>
        </th>
        <td mat-cell *matCellDef="let element">
          <span class="mobile-view mobile-view-title">Seq. identity</span>{{ element.sequenceIdentity }}%
        </td>
      </ng-container>

      <ng-container matColumnDef="averagePlddt">
        <th class="fifth" mat-header-cell *matHeaderCellDef>Average <br/>pLDDT</th>
        <td mat-cell *matCellDef="let element">
          <span class="mobile-view mobile-view-title">Average pLDDT</span>{{ element.averagePlddt }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumnsBFVDStructure"></tr>
      <tr mat-row *matRowDef="let element; columns: displayedColumnsBFVDStructure;"
        class="example-element-row" [ngClass]="isExpandedBFVD(element) ? 'example-expanded-row' : ''"
        (click)="toggleRowBFVD(element)"></tr>
      <tr mat-row *matRowDef="let row; columns: ['expandedDetailBFVD']" class="example-detail-row"></tr>
      @for (row of bfvdStructureDataSource?.data; track row) {
        @if (isExpandedBFVD(row)) {
          <tr mat-row *matRowDef="let row; columns: ['expandedDetailBFVD']; when: isExpansionDetailRowBFVD" class="example-detail-row"></tr>
        }
      }
    </table>
  </div>

  @if (errorBFVD) {
    <div class="threedViewer structureContainer mobile-error-msg fullwidth">
      <p class="noRecMsg">{{ errorBFVD }}</p>
    </div>
  }

  <div>
    <mat-paginator [length]="foldseekService.totalBFVD()" [pageSize]="recordsBFVD" [pageIndex]="currentBFVDPage"
      [pageSizeOptions]="[5, 10, 25, 50, 100]" aria-label="Select page" (page)="handlePageEvent($event)">
    </mat-paginator>
  </div>
}
